import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useWizardStyles = makeStyles({
  wizardContainer: {
    width: '100%',
    height: '100%',
    '& .error': {
      color: '#A80000',
    },
    '& .ui-blocker-indicator': {
      maxWidth: '376px',
    },
    '& .card-layout': {
      '& .footer-container': {
        display: 'none',
      },
    },
  },
  footer: {
    ...shorthands.borderTop('1px', 'solid', tokens.colorNeutralStroke2),

    '& .basic-step-footer': {
      ...shorthands.borderTop('none'),
    },
  },
});
